<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">Users Countries</p>

    <small class="mb-2 d-inline-block">Results shown are from current data only, date range applied does not change results</small>

    <section class="call-stats__items" v-if="!loading">
      <p class="text-center title-divider top-divider font-weight-bold">
        Country breakdown of verified users
      </p>

      <section v-if="tableStats.length > 0">
        <b-table
          class="data-table mt-2"
          hover
          :fields="headers"
          :items="tableStats"
          :per-page="-1">
        </b-table>
      </section>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import axios from 'axios';
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';
  import HelperService from '../../../services/HelperService';

  const CountryCodes = require('../../country/countryCodes.json');

  export default {
    components: {},
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        curReq: null,
        helperService: new HelperService(),
        loading: true,
        stats: [],
        tableStats: [],
        headers: [
          { label: 'Country', key: 'country' },
          { label: 'Total', key: 'total' },
        ],
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getStats();
        },
        deep: true,
      },
    },
    mounted() {
      this.getStats();
    },
    methods: {
      getStats() {
        this.loading = true;
        if (this.curReq) {
          this.curReq.cancel('cancelled');
        }

        this.curReq = BiStatsService.createCancelToken();

        BiStatsService.getVisitorCountries(this.filters, this.curReq.token).then(res => {
          this.stats = res.data;
          this.setUpTableData(this.stats);
          this.curReq = null; // mark the request as complete
        }).catch(err => {
          // console.log('could not get visitor users country stats', err);
          if (!axios.isCancel(err)) {
            this.$toast.error('Could not get users country stats, please refresh and try again', {
              toastClassName: ['toast-std', 'warning-toast'],
            });
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      setUpTableData(countryData) {
        this.tableStats = []; // reset stats

        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(countryData.countries)) {
            this.tableStats.push({
              country: this.formatCountryLabel(key),
              total: value,
            });
        }

        this.tableStats.sort((a, b) => b.total - a.total); // sort by total
      },
      formatCountryLabel(text) {
        const country = CountryCodes.find(item => item.code === text);
        return country ? country.name : text;
      },
    },
  };
</script>
